import { toast } from 'react-toastify'

import { AppMsg, AppMsgType, ValidationErrorCode } from 'cat-shared/utils'
import i18n from 'client/dictionary/i18n'

const { t } = i18n

export const displaySnackBar = ({ code, type, text }: AppMsg) => {
  if (code) {
    toast[type](t(`apiMsgs.${code}`))
  } else {
    toast[type](text)
  }
}

export const displayRequestTimeoutError = () => {
  toast.error(t('common.errors.requestTimeout'))
}

export const displaySomethingWentWrongError = () => {
  toast.error(t('common.errors.somethingWentWrong'))
}

export const displayFormValidationError = (
  fieldName: string,
  msg?: string,
  validationErrorCode?: ValidationErrorCode
) => {
  let text = ''
  const fieldNameUpperCased = `${fieldName.charAt(0).toUpperCase()}${fieldName.substring(1)}`
  if (validationErrorCode) {
    text = `${fieldNameUpperCased} - ${t(`apiValidationErrors.${validationErrorCode}`)}`
  } else if (msg) {
    text = `${fieldNameUpperCased} - ${msg}`
  }
  displaySnackBar({
    type: AppMsgType.Error,
    text,
  })
}
